var _rect, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfTrinidadAndTobago({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 480,
    viewBox: "0 0 30 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#da1a35",
    width: 30,
    height: 18
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "0,0 20.824734,18 30,18 9.175266,0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1.52921,0 22.353945,18 28.470789,18 7.646055,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfTrinidadAndTobago);
export default __webpack_public_path__ + "static/media/Flag_of_Trinidad_and_Tobago.fae15b9e8868a0368d8388454d6e5d01.svg";
export { ForwardRef as ReactComponent };